import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"

interface Props {
  className?: string
}

export function ChevronIcon(props: Props) {
  const { _ } = useLingui()

  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Frame">
        <title>{_(msg`Chevron Icon`)}</title>
        <path
          id="Vector"
          d="M1 1L7 7L13 1"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
